/**
 * @license Copyright (c) 2017-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md.
 */

import mediumZoom from 'medium-zoom'

export default function imageModal() {

	const lightboxImages = document.querySelectorAll( '[data-lightbox]' );

	if( !lightboxImages ) {
		return;
	}

	mediumZoom( lightboxImages );

}
